import { Button } from '@talentmesh/ui/components/button';
import { Spinner } from '@talentmesh/ui/components/spinner';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@talentmesh/ui/components/tooltip';
import { X } from 'lucide-react';
import { ImageCropContextProps } from './ImageCropContext';
import { ImageCropStrings } from './ImageCropUtils';

export interface ImageCropRemoveButtonProps
    extends Pick<ImageCropStrings, 'removeButtonTooltipText'>, Pick<ImageCropContextProps, 'processing'> {
    onClick: () => void;
}

export const ImageCropRemoveButton = ({ onClick, processing, removeButtonTooltipText }: ImageCropRemoveButtonProps) => {
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button
                        type="button"
                        data-cy="ImageCropRemoveButton"
                        variant="ghost"
                        disabled={processing}
                        onClick={onClick}
                        className="bg-background size-7.5 rounded-full p-2 shadow-md hover:bg-red-400"
                    >
                        {processing ? (
                            <Spinner className="size-4.5" />
                        ) : (
                            <X className="text-muted-foreground size-4.5" data-testid="CloseIcon" />
                        )}
                    </Button>
                </TooltipTrigger>
                <TooltipContent side="top">
                    <span className="text-xs">{removeButtonTooltipText}</span>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};
